const n = (o) => ({
  accordian: {
    padding: 0
  },
  accordianItem: {
    backgroundColor: "transparent",
    boxShadow: "none",
    margin: 0,
    minHeight: 52,
    "&.Mui-expanded": {
      margin: 0
    },
    "&:before": {
      content: "none"
    }
  },
  accordianSummary: {
    margin: 0,
    color: o.palette.common.grey400,
    fontSize: o.typography.fontSize16,
    backgroundColor: "transparent",
    borderRadius: 16,
    lineHeight: 1.5,
    minHeight: 52,
    "&.Mui-expanded": {
      color: o.palette.common.white,
      backgroundColor: o.palette.common.blue300,
      minHeight: 52
    },
    "& .Mui-expanded": {
      color: o.palette.common.white,
      margin: 0
    },
    "& .MuiAccordionSummary-content": {
      margin: "18px 0",
      "&.Mui-expanded": {}
    }
  },
  accordianDetail: {
    position: "relative",
    color: o.palette.common.grey400,
    fontSize: o.typography.fontSize16,
    lineHeight: 1.5,
    padding: "28px 16px",
    paddingLeft: 80,
    "&:before": {
      content: '""',
      position: "absolute",
      left: 40,
      top: 0,
      height: "100%",
      width: 1,
      backgroundColor: o.palette.common.blue100
    },
    "@media(max-width: 600px)": {
      paddingLeft: 50,
      "&:before": {
        left: 20
      }
    }
  }
}), e = n;
export {
  e as default
};
